import useSWR from 'swr'
import { guardClient } from '../_axios'

/**
 * ユーザー情報の全件取得
 * [get]/company/list
 */
export type UserDataType = {
  id: string
  code: string
  email: string
  firstName: string
  lastName: number
  authorityCode: 'GENERAL' | 'ADMIN'
  version: string
}
type ResponseUsers = { data: UserDataType[] }

const allUsersFetcher = async (urlTail: string) => {
  try {
    const response = await guardClient.get<ResponseUsers>(urlTail)
    return response.data
  } catch (error) {
    Promise.reject(error)
  }
}
export const useAllUsers = () => {
  const path = '/users/list'
  const { data, mutate } = useSWR(path, allUsersFetcher, {
    suspense: true,
    revalidateOnFocus: false
  })
  if (data === undefined) {
    throw new Error()
  }
  return { users: data.data, mutate }
}
